<div class="cq-page">

  <div class="cq-tabs">
    <button class="cq-tab" [class.active]="activeTab==='my'" (click)="switchTab('my')">
      <mat-icon>assignment</mat-icon> My Requests
    </button>
    <button class="cq-tab" *ngIf="isManagerOrHr()" [class.active]="activeTab==='team'" (click)="switchTab('team')">
      <mat-icon>how_to_reg</mat-icon> Team Requests
      <span class="cq-tab-badge" *ngIf="pendingTeamCount">{{ pendingTeamCount }}</span>
    </button>
    <button class="cq-tab" *ngIf="isHrAdmin()" [class.active]="activeTab==='all'" (click)="switchTab('all')">
      <mat-icon>account_tree</mat-icon> All Requests
      <span class="cq-tab-badge" *ngIf="pendingAllCount">{{ pendingAllCount }}</span>
    </button>
  </div>

  <div class="cq-skel sk-fade" *ngIf="loading">
    <div class="cq-toolbar">
      <span class="sk-line" style="width:60%;max-width:420px;height:13px"></span>
      <span class="sk-btn" style="width:130px;margin-left:auto"></span>
    </div>
    <div class="cq-card sk-surface" style="padding:0;overflow:hidden">
      <div class="cq-skel-grid cq-skel-head">
        <span class="sk-line" style="width:50px"></span>
        <span class="sk-line" style="width:80px"></span>
        <span class="sk-line" style="width:70px"></span>
        <span class="sk-line" style="width:50px;margin:0 auto"></span>
        <span class="sk-line" style="width:90px"></span>
        <span class="sk-line" style="width:56px;margin:0 auto"></span>
      </div>
      <div class="cq-skel-grid cq-skel-row" *ngFor="let r of [1,2,3,4,5,6]">
        <span class="sk-chip" style="width:80px"></span>
        <div class="sk-stack" style="gap:6px"><span class="sk-line" style="width:80%"></span><span class="sk-line sk-sm" style="width:50%"></span></div>
        <span class="sk-line" style="width:90%"></span>
        <span class="sk-chip" style="margin:0 auto"></span>
        <span class="sk-line" style="width:70%"></span>
        <span class="sk" style="width:70px;height:26px;border-radius:7px;margin:0 auto"></span>
      </div>
    </div>
  </div>

  <ng-container *ngIf="activeTab==='my' && !loading">
    <div class="cq-toolbar">
      <p class="cq-hint">Request a change to your <strong>shift / roster</strong> — it goes to your manager for approval.</p>
      <button class="cq-add-btn" (click)="openNew()"><mat-icon>add</mat-icon> New Request</button>
    </div>

    <div class="cq-card">
      <table class="cq-table" *ngIf="myRequests.length; else myEmpty">
        <thead><tr><th>Type</th><th>Requested</th><th>Reason</th><th class="cq-center">Status</th><th>Manager Note</th><th class="cq-center">Action</th></tr></thead>
        <tbody>
          <tr *ngFor="let r of myRequests">
            <td><span class="cq-type">{{ typeLabel(r.type) }}</span></td>
            <td><span class="cq-target">{{ targetDisplay(r) }}</span><div class="cq-eff" *ngIf="r.effectiveDate">from {{ r.effectiveDate | date:'d MMM yyyy' }}</div></td>
            <td><div class="cq-reason">{{ r.reason }}</div></td>
            <td class="cq-center"><span class="cq-badge" [ngClass]="statusClass(r.status)">{{ r.status | titlecase }}</span></td>
            <td><span class="cq-muted">{{ r.managerComments || '—' }}</span></td>
            <td class="cq-center">
              <button class="cq-mini cq-mini--rej" *ngIf="(r.status||'').toLowerCase()==='pending'" [disabled]="busy[r.id]" (click)="withdraw(r)">Withdraw</button>
              <span *ngIf="(r.status||'').toLowerCase()!=='pending'" class="cq-muted">—</span>
            </td>
          </tr>
        </tbody>
      </table>
      <ng-template #myEmpty>
        <div class="cq-empty"><mat-icon>assignment</mat-icon><p>No change requests yet</p>
          <button class="cq-add-btn" (click)="openNew()"><mat-icon>add</mat-icon> New Request</button>
        </div>
      </ng-template>
    </div>
  </ng-container>

  <ng-container *ngIf="activeTab==='team' && !loading">
    <div class="cq-toolbar">
      <div class="cq-filter-chips">
        <button class="cq-chip" *ngFor="let o of statusOptions" [class.active]="statusFilter===o.value" (click)="statusFilter=o.value">{{ o.label }}</button>
      </div>
    </div>

    <div class="cq-card">
      <table class="cq-table" *ngIf="filteredTeam.length; else teamEmpty">
        <thead><tr><th>Employee</th><th>Type</th><th>Requested</th><th>Reason</th><th class="cq-center">Status</th><th class="cq-center">Action</th></tr></thead>
        <tbody>
          <tr *ngFor="let r of filteredTeam">
            <td>
              <div class="cq-emp">
                <div class="cq-av">{{ initials(r.employeeName) }}</div>
                <div><div class="cq-emp-name">{{ r.employeeName || 'Unknown' }}</div><div class="cq-emp-code">{{ r.employeeCode || '—' }}</div></div>
              </div>
            </td>
            <td><span class="cq-type">{{ typeLabel(r.type) }}</span></td>
            <td><span class="cq-target">{{ targetDisplay(r) }}</span><div class="cq-eff" *ngIf="r.effectiveDate">from {{ r.effectiveDate | date:'d MMM yyyy' }}</div></td>
            <td><div class="cq-reason">{{ r.reason }}</div></td>
            <td class="cq-center"><span class="cq-badge" [ngClass]="statusClass(r.status)">{{ r.status | titlecase }}</span></td>
            <td class="cq-center">
              <div class="cq-actions" *ngIf="(r.status||'').toLowerCase()==='pending'; else decided">
                <button class="cq-mini cq-mini--rej" [disabled]="busy[r.id]" (click)="decide(r,'rejected')">Reject</button>
                <button class="cq-mini cq-mini--app" [disabled]="busy[r.id]" (click)="decide(r,'approved')">Approve</button>
              </div>
              <ng-template #decided><span class="cq-muted">—</span></ng-template>
            </td>
          </tr>
        </tbody>
      </table>
      <ng-template #teamEmpty>
        <div class="cq-empty"><mat-icon>how_to_reg</mat-icon><p>No requests from your team</p></div>
      </ng-template>
    </div>
  </ng-container>

  <ng-container *ngIf="activeTab==='all' && !loading">
    <div class="cq-toolbar">
      <p class="cq-hint">Organisation-wide view of every roster request — HR / Admin can act on any of them.</p>
      <div class="cq-filter-chips">
        <button class="cq-chip" *ngFor="let o of statusOptions" [class.active]="statusFilter===o.value" (click)="statusFilter=o.value">{{ o.label }}</button>
      </div>
    </div>

    <div class="cq-card">
      <table class="cq-table" *ngIf="filteredAll.length; else allEmpty">
        <thead><tr><th>Employee</th><th>Type</th><th>Requested</th><th>Reason</th><th class="cq-center">Status</th><th class="cq-center">Action</th></tr></thead>
        <tbody>
          <tr *ngFor="let r of filteredAll">
            <td>
              <div class="cq-emp">
                <div class="cq-av">{{ initials(r.employeeName) }}</div>
                <div><div class="cq-emp-name">{{ r.employeeName || 'Unknown' }}</div><div class="cq-emp-code">{{ r.employeeCode || '—' }}</div></div>
              </div>
            </td>
            <td><span class="cq-type">{{ typeLabel(r.type) }}</span></td>
            <td><span class="cq-target">{{ targetDisplay(r) }}</span><div class="cq-eff" *ngIf="r.effectiveDate">from {{ r.effectiveDate | date:'d MMM yyyy' }}</div></td>
            <td><div class="cq-reason">{{ r.reason }}</div></td>
            <td class="cq-center"><span class="cq-badge" [ngClass]="statusClass(r.status)">{{ r.status | titlecase }}</span></td>
            <td class="cq-center">
              <div class="cq-actions" *ngIf="(r.status||'').toLowerCase()==='pending'; else decidedAll">
                <button class="cq-mini cq-mini--rej" [disabled]="busy[r.id]" (click)="decide(r,'rejected')">Reject</button>
                <button class="cq-mini cq-mini--app" [disabled]="busy[r.id]" (click)="decide(r,'approved')">Approve</button>
              </div>
              <ng-template #decidedAll><span class="cq-muted">—</span></ng-template>
            </td>
          </tr>
        </tbody>
      </table>
      <ng-template #allEmpty>
        <div class="cq-empty"><mat-icon>account_tree</mat-icon><p>No roster requests in the organisation</p></div>
      </ng-template>
    </div>
  </ng-container>
</div>

<div class="cq-drawer-overlay" [class.open]="showForm" (click)="closeForm()"></div>
<div class="cq-drawer" [class.open]="showForm">
  <div class="cq-dr-head">
    <h3>Request Roster Change</h3>
    <button class="cq-dr-close" (click)="closeForm()"><mat-icon>close</mat-icon></button>
  </div>
  <div class="cq-dr-body">
    <div class="cq-fg">
      <label>Requested Shift <span class="req">*</span></label>
      <select [(ngModel)]="form.targetId">
        <option value="">Select shift…</option>
        <option *ngFor="let s of shifts" [value]="s.id">{{ s.name }} · {{ (s.startTime||'').slice(0,5) }}–{{ (s.endTime||'').slice(0,5) }}</option>
      </select>
    </div>
    <div class="cq-fg">
      <label>Effective From</label>
      <input type="date" [(ngModel)]="form.effectiveDate">
    </div>

    <div class="cq-fg">
      <label>Reason <span class="req">*</span></label>
      <textarea rows="3" [(ngModel)]="form.reason" placeholder="Why do you need this roster change?"></textarea>
    </div>
  </div>
  <div class="cq-dr-foot">
    <button class="cq-btn-ghost" (click)="closeForm()">Cancel</button>
    <button class="cq-btn-primary" [disabled]="submitting" (click)="submit()">{{ submitting ? 'Submitting…' : 'Submit Request' }}</button>
  </div>
</div>
